export const SIDE_MENU_WIDTH_DESKTOP = 288;
export const MOBILE_SEARCH_HEADER_HEIGHT = 81;
export const MOBILE_HEADER_HEIGHT = 56;
export const MOBILE_HEADER_PADDING_X = 16;
export const HEADER_HEIGHT = 56;
export const HEADER_PADDING_X = 48;
export const FOOTER_MAX_HEIGHT = 53;
export const FOOTER_PADDING = 48;
export const LAYOUT_CONTAINER_ID = 'layout__container';
export const LOGO_DESKTOP_WIDTH = 38;
export const ROWS_PER_PAGE = 5;
export const FEATURE_VIDEOS_DESKTOP = 3;
export const FEATURE_VIDEOS_TABLET = 2;
export const FEATURE_VIDEOS_MOBILE = 0;
